// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const DuplicatePlusIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16",
  "aria-hidden": "true",
  "data-icon": "DuplicatePlus/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M5.333 10.664H4a1.333 1.333 0 0 1-1.333-1.333V3.997c0-.736.596-1.333 1.333-1.333h5.333c.737 0 1.333.597 1.333 1.333v1.334m-4 8H12c.736 0 1.333-.597 1.333-1.334V6.664c0-.736-.597-1.333-1.333-1.333H6.667c-.737 0-1.334.597-1.334 1.333v5.333c0 .737.597 1.334 1.333 1.334ZM9.382 7.383v2m0 0v2m0-2h2m-2 0h-2"
}));
export default DuplicatePlusIcon;
